export default "__VITE_ASSET__Dsy8E5gL__"